/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 * See the LICENSE file for the full text.
 */

/**
 * A title turned into the URL-safe `event.slug`.
 *
 * The admin form asks an admin to type this. An organizer should not have to
 * think about it, and a hand-typed slug is a way to get a mismatch between what
 * the event is called and what its link says. Derived is both fewer fields and
 * more consistent data.
 *
 * Deliberately ASCII-only: the column feeds a public URL, and a percent-encoded
 * Kannada title in a link people paste into WhatsApp is worse than a shortened
 * one. A title with nothing ASCII in it yields '' and the caller omits the
 * column, leaving the platform to do whatever it does with a missing slug —
 * rather than writing a string of hyphens.
 */

/** Longest slug we will emit. Generous for a URL, short of any column limit. */
export const MAX_SLUG_LENGTH = 120;

export function slugify(title) {
  if (!title || typeof title !== 'string') return '';
  return title
    // Split accented characters into base + combining mark, then drop the mark,
    // so "Café" becomes "cafe" rather than losing the letter entirely.
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SLUG_LENGTH)
    // The slice can land mid-separator; trim again so the slug never ends in a
    // hyphen.
    .replace(/-+$/, '');
}
